var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',_vm._b({attrs:{"items":_vm.seasonsMapped,"menu-props":_vm.menuProps,"item-value":"id","item-text":"displayName","return-object":"","hide-details":"","outlined":""},model:{value:(_vm.season),callback:function ($$v) {_vm.season=$$v},expression:"season"}},'v-select',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }